import React, {useEffect, useState} from "react";
import {Song} from "../../../types/generic";
import {getSongs} from "../../../queries/highlightQueries";
import StyledAutoComplete from "../StyledAutocomplete/StyledAutocomplete";
import {Box} from "@mui/material";
import Grid from "@mui/material/Grid";
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';

interface SongSelectionProps{
    music: Song | null;
    onSongChange: (song: Song) => void;
}

const SongSelection: React.FC<SongSelectionProps> = ({music, onSongChange}) => {

    const [songOptions, setSongOptions] = useState<Song[]>([])

    async function loadSongOptions(){
        try{
            const songs = await getSongs()
            setSongOptions(songs)
        }catch (error){
            console.error("Trouble retrieving songs", error);
        }
    }

    useEffect(() => {
        loadSongOptions()
    }, []);

    return (
        <Grid container width={'100%'} alignItems={'center'}>
            <Grid item xs = {6}>
                <StyledAutoComplete
                    name={'songSelection'}
                    label={'Songs'}
                    options={songOptions}
                    value={music && music.file_name ? music :  ''}
                    onChange={(value, newValue) => onSongChange(newValue)}
                    labelField={'label'}
                    valueField={'file_name'}
                    multiple={false}
                />
            </Grid>
            <Grid item xs = {6}>
                {music && music?.src_url && <AudioPlayer
                    autoPlay={false}
                    src={music?.src_url}
                />}
            </Grid>
        </Grid>
        )
}

export default SongSelection